import { Table } from '@mantine/core';
import { Title } from '../../../components/Title';
import { formatToCurrency } from '../../../util/formatting';
import type { BankingDto } from '../types/BankingDto';
import { KeyedRow } from '../../../components/KeyedRow';

export function ExtraBankingInfoRow({ banking }: { banking: BankingDto }) {
	return (
		<>
			<Table>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'Declared'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Actual Cash'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Discrepancy'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Cash'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Cash Invoices'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Cards'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Change Held'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Float Held'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Balance'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					<KeyedRow>
						<Table.Td>{formatToCurrency(banking.declared)}</Table.Td>
						<Table.Td>{formatToCurrency(banking.actualCash)}</Table.Td>
						<Table.Td>{formatToCurrency(banking.discrepancy)}</Table.Td>
						<Table.Td>{formatToCurrency(banking.cash)}</Table.Td>
						<Table.Td>{formatToCurrency(banking.cashInvoice)}</Table.Td>
						<Table.Td>{formatToCurrency(banking.cards)}</Table.Td>
						<Table.Td>{formatToCurrency(banking.changeHeld)}</Table.Td>
						<Table.Td>{formatToCurrency(banking.floatHeld)}</Table.Td>
						<Table.Td>{formatToCurrency(banking.balance)}</Table.Td>
					</KeyedRow>
				</Table.Tbody>
			</Table>
		</>
	);
}
